import { get, post, put, httpDelete } from "../HttpService";

export class SolutionGuideService {
  static list = (queryData = {}, config = {}) => {
    return get(`solution_guide`, queryData, config);
  };
  static lookup = (alert_type, message, config = {}) => {
    return get(`solution_guide/lookup`, { alert_type, message }, config);
  };
  static create = (queryData = {}, config = {}) => {
    return post(`solution_guide`, queryData, config);
  };
  static update = (queryData = {}, config = {}) => {
    return put(`solution_guide/${queryData.id}`, queryData, config);
  };
  static delete = (queryData = {}, config = {}) => {
    return httpDelete(`solution_guide/${queryData.id}`, queryData, config);
  };
}
